import { FilterGroup } from '@customer/filters/types';
import { useAppSelector } from '@customer/store/hooks';
import useFilters from '@customer/filters/useFilters';
import { useGetInteractionsSummaryQuery } from '@customer/store/apis/interactionsApi';
import InsightsCardVI from '@customer/components/data-display/insights-card-vi/InsightsCardVI';
import { AssetListScenarios, PerformanceVIAssetsFilters } from '@customer/store/apis/assetsApi';
import { useLocationFilterParams } from '@customer/store/slices/locationFilterSlice';
import { usePerformanceTimeRangeFilters } from '@customer/store/slices/globalSlice';

const scenario = AssetListScenarios.PerformanceVehicleInteractions;
const filterGroup = FilterGroup.PerformanceVI;

export function VehicleInteractionsOverview() {
  const siteId = useAppSelector(state => state.auth.siteId);

  const timeRangeFilters = usePerformanceTimeRangeFilters();

  const filters = useFilters<PerformanceVIAssetsFilters>(filterGroup);

  const locationFilters = useLocationFilterParams({ filterGroup });

  const { currentData: interactionsSummaryData } = useGetInteractionsSummaryQuery(
    {
      query: {
        ...filters,
        ...locationFilters,
        ...timeRangeFilters,
        scenario,
      },
    },
    {
      refetchOnMountOrArgChange: 60,
      skip: typeof siteId === 'undefined',
    },
  );

  return <InsightsCardVI summaries={interactionsSummaryData?.vi} />;
}

export default VehicleInteractionsOverview;
